"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATABASE_CELL_ATTACHMENT_SOURCE_PART_POSITION = exports.DATABASE_CELL_ATTACHMENT_SOURCE_PREFIX = exports.DATABASE_CELL_ATTACHMENT_SOURCE_KIND = void 0;
exports.encodeDatabaseCellAttachmentSourcePart = encodeDatabaseCellAttachmentSourcePart;
exports.buildDatabaseCellAttachmentSourceKey = buildDatabaseCellAttachmentSourceKey;
exports.isDatabaseCellAttachmentSourceKey = isDatabaseCellAttachmentSourceKey;
exports.parseDatabaseCellAttachmentSourceKey = parseDatabaseCellAttachmentSourceKey;
/**
 * The key of a file a database file cell holds, for its PDF pages, search hits
 * and viewer. Server and browser build and read it here only.
 *
 * Every part is URI-encoded, so no part holds the separator: a key splits into
 * exactly its parts, and a part compares exactly (the SQL `split_part` of the
 * PDF page store relies on it).
 */
exports.DATABASE_CELL_ATTACHMENT_SOURCE_KIND = 'database-cell-v2';
exports.DATABASE_CELL_ATTACHMENT_SOURCE_PREFIX = `${exports.DATABASE_CELL_ATTACHMENT_SOURCE_KIND}:`;
/** 1-based position of each part in a key, as SQL `split_part` counts. */
exports.DATABASE_CELL_ATTACHMENT_SOURCE_PART_POSITION = {
    databaseId: 2,
    rowId: 3,
    columnId: 4,
    refId: 5,
    blobId: 6,
};
/** One part as a key stores it. */
function encodeDatabaseCellAttachmentSourcePart(value) {
    return encodeURIComponent(value);
}
function buildDatabaseCellAttachmentSourceKey(parts) {
    return [
        exports.DATABASE_CELL_ATTACHMENT_SOURCE_KIND,
        parts.databaseId,
        parts.rowId,
        parts.columnId,
        parts.refId,
        parts.blobId,
    ]
        .map((part, index) => index === 0 ? part : encodeDatabaseCellAttachmentSourcePart(part))
        .join(':');
}
function isDatabaseCellAttachmentSourceKey(key) {
    return key.startsWith(exports.DATABASE_CELL_ATTACHMENT_SOURCE_PREFIX);
}
function decodedPart(value) {
    if (!value)
        return null;
    try {
        return decodeURIComponent(value);
    }
    catch {
        return null;
    }
}
/** The parts of a key; null when `key` is none or any part is empty. */
function parseDatabaseCellAttachmentSourceKey(key) {
    const stored = key.split(':');
    if (stored.length !== 6 || stored[0] !== exports.DATABASE_CELL_ATTACHMENT_SOURCE_KIND)
        return null;
    const [databaseId, rowId, columnId, refId, blobId] = stored
        .slice(1)
        .map(decodedPart);
    if (!databaseId || !rowId || !columnId || !refId || !blobId)
        return null;
    return { databaseId, rowId, columnId, refId, blobId };
}
